module.exports = __webpack_public_path__ + "img/manual-tran.756cc8f6.png";